import React from 'react';

const MessageSkeleton: React.FC = () => {
  return (
    <div
      className={
        'w-full block relative overflow-hidden rounded-xl border bg-light-surface dark:bg-secondary-dark border-light-border-default dark:border-gray-700 shadow-sm animate-pulse'
      }
    >
      {/* Unread indicator placeholder */}
      <div className="absolute top-0 left-0 w-1 h-full bg-gray-200 dark:bg-gray-700" />

      <div className="pt-6 px-6 pb-2 min-w-0">
        <div className="flex items-start justify-between gap-4 ">
          <div className="flex items-start gap-4 flex-1 min-w-0">
            {/* Icon skeleton */}
            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-200 dark:bg-gray-700" />

            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-2 mb-3">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-3">
                    {/* Title skeleton */}
                    <div className="h-5 w-1/3 mt-2 rounded bg-gray-200 dark:bg-gray-700" />
                    {/* Badge skeleton */}
                    <div className="h-6 w-20 rounded-full bg-gray-200 dark:bg-gray-700" />
                  </div>
                  {/* Description skeleton */}
                  <div className="mb-4 mt-2 space-y-2">
                    <div className="h-4 w-3/6 rounded bg-gray-200 dark:bg-gray-700" />
                  </div>
                  {/* Actions skeleton */}
                  <div className="flex items-center gap-3  mt-6">
                    <div className="h-7 w-24 rounded-lg bg-gray-200 dark:bg-gray-700" />
                    <div className="h-7 w-20 rounded-lg bg-gray-200 dark:bg-gray-700" />
                  </div>
                </div>
                {/* Time skeleton */}
                <div className="flex items-center gap-3 flex-shrink-0">
                  <div className="h-4 w-24 rounded bg-gray-200 dark:bg-gray-700" />
                  <div className="h-8 w-8 rounded-lg bg-gray-200 dark:bg-gray-700" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageSkeleton; 